__turbopack_context__.v({
  "buttonLabel": "MoL0pG_buttonLabel",
  "isSubmitting": "MoL0pG_isSubmitting",
  "rotation": "MoL0pG_rotation",
  "spinner": "MoL0pG_spinner",
  "submitButton": "MoL0pG_submitButton",
});
